import { removeNamespace } from '@piri/vue-utils';

import moduleName from './moduleName';
import getterTypes from './types/getterTypes';

const getterTypesInModule = removeNamespace(moduleName, getterTypes);

const authors = state => state.authors;

export default {
  [getterTypesInModule.AUTHORS]: authors,
};
